<style lang="less">
  // @import '../flow.less';
  @import '../flow/base.less';
</style>
<template>
    <!-- <Tabs v-model="defaultIndex" @on-click="handleTabClick"> -->
        <!-- <TabPane label="跳板机用户" name="SpringBoardUserList">
          <SpringBoardUserList ref="SpringBoardUserList"/>
        </TabPane>
        <TabPane label="系统用户" name="SystemUserList">
          <SystemUserList  ref="SystemUserList"/>
        </TabPane> -->
        <!-- <TabPane label="权限分配" name="PermList">
          <PermList ref="PermList"/>
        </TabPane> -->
        <!-- <TabPane label="日志审计" name="SpringBoardLogs">
          <SpringBoardLogs ref="SpringBoardLogs"/>
        </TabPane> -->
    <!-- </Tabs> -->
    <SpringBoardLogs ref="SpringBoardLogs"/>
</template>
<script>
// import { getProjectDetail, ProjectBaseInfoSubmit } from '@/api/project'
import SpringBoardUserList from './SpringBoardUserList'
import SystemUserList from './SystemUserList'
import PermList from './PermList'
import SpringBoardLogs from './SpringBoardLogs'
export default {
  name: 'SpringBoardMain',
  components: {
    'SpringBoardUserList': SpringBoardUserList,
    'SystemUserList': SystemUserList,
    'PermList': PermList,
    'SpringBoardLogs': SpringBoardLogs
  },
  data () {
    return {
      data: {},
      defaultIndex: 'SpringBoardLogs'
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.index) {
        if (this.$route.query.index === 3) {
          this.defaultIndex = 'SpringBoardLogs'
        }
      }
    }
  },
  methods: {
    // getProjectDetail (id) {
    //   let params = {
    //     id: id
    //   }
    //   getProjectDetail(params).then(res => {
    //     this.data = res.data
    //   })
    // },
    // // submit project 基本信息表单
    // handleEditorSubmit (values) {
    //   ProjectBaseInfoSubmit(this.$route.query.id, values).then(res => {
    //     if (res.data.id > 0) {
    //       this.$router.push({name: 'ProjectDetail', query: {id: res.data.id}})
    //     } else {
    //       this.$Message.error(res.data)
    //     }
    //   })
    // }
    handleTabClick (value) {
      if (value === 'SpringBoardUserList') {
        this.$refs.SpringBoardUserList.getSpringBoradUserList()
      } else if (value === 'SystemUserList') {
      } else if (value === 'PermList') {
      } else if (value === 'SpringBoardLogs') {
        this.$refs.SpringBoardLogs.getSpringBoradLogList()
      }
    }
  },
  mounted: function () {
    this.$refs.SpringBoardLogs.getSpringBoradLogList()
    // this.getProjectDetail(this.$route.query.id)
  }
}
</script>
